<template>
    <div id="FLOATING_SHEET" v-show='isShowCheatSheet'>
        <strong class="subtitle">Markdown(GFM) Cheat Sheet</strong>

        <sheet-table />

        <p class="text-right"><button @click=' $emit("toggle-sheet") '>닫기</button></p>
    </div>
</template>

<script>
import SheetTable from "./CheatSheetTable.vue";

export default {
    props: {
        isShowCheatSheet: { type: Boolean, default: false }
    },
    components: {
        "sheet-table": SheetTable
    }
}
</script>

<style>
#FLOATING_SHEET {
    position: fixed;
    top: 128px; right: 100px;
    min-width: 50vw; max-height: 80vh;
    overflow-y: auto;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 0 5px 5px #f7f7f7;
    box-sizing: border-box;
    padding: 8px;
    z-index: 999;
}

#FLOATING_SHEET .subtitle {
    display: block;
    font-size: 1.5em;
    padding: 8px 4px 16px;
    border-bottom: 1px dotted #ccc;
}

#FLOATING_SHEET .mdtable {
    font-size: 0.9em;
}
</style>